import uuid from './utils/uuid';
import getset from './utils/getset';
import hash from 'object-hash';

export default class BaseModel {
  constructor(data = {}) {
    Object.defineProperty(this, 'vKey', {
      value: uuid(),
    });

    getset(this, this.casts());

    this.fill(_.isPlainObject(data) ? data : {});
    this.saveMode();
  }

  casts() {
    return {};
  }

  fill(data = {}) {
    if (!_.isPlainObject(data)) return this;

    for (let key in this.casts()) {
      let value = data[key];
      this[key] = value !== undefined ? value : null;
    }

    return this;
  }

  toJson(call = 'toJson', ignore = []) {
    let data = {};

    for (let key in this.casts()) {
      if (ignore.includes(key)) continue;

      let value = this[key];

      if (Array.isArray(value)) {
        let arr = [];

        value.forEach((item) => {
          if (item === undefined) return;
          arr.push(item instanceof BaseModel ? item[call]() : item);
        });

        data[key] = arr;

      } else if (value !== undefined) {
        data[key] = value instanceof BaseModel ? value[call]() : value;
      }
    }

    return data;
  }

  serialize(ignore = []) {
    return this.toJson('serialize', ignore);
  }

  clone() {
    return new this.constructor(this.toJson());
  }

  reset(ignore = []) {
    for (let key in this.casts()) {
      if (ignore.includes(key)) continue;
      this[key] = null;
    }
  }

  saveMode() {
    this.__hash = hash(this.serialize());
  }

  isChanged() {
    return this.__hash != hash(this.serialize());
  }

  formatDate(date = '', addTime = false) {
    if (date && addTime) date += 'T00:00:00';

    return new Intl.DateTimeFormat('pt-BR', {
      year: 'numeric', month: '2-digit', day: '2-digit',
    }).format(new Date(date));
  }

  formatDatetime(datetime = '') {
    return new Intl.DateTimeFormat('pt-BR', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', //timeZone: 'America/Sao_Paulo',
    }).format(new Date(datetime));
  }

  formatCurrency(value = 0) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency', currency: 'BRL',
    }).format(value);
  }
}
